import { render, staticRenderFns } from "./addGoods.vue?vue&type=template&id=37b9de35&scoped=true&"
import script from "./addGoods.vue?vue&type=script&lang=js&"
export * from "./addGoods.vue?vue&type=script&lang=js&"
import style0 from "./addGoods.vue?vue&type=style&index=0&id=37b9de35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b9de35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b9de35')) {
      api.createRecord('37b9de35', component.options)
    } else {
      api.reload('37b9de35', component.options)
    }
    module.hot.accept("./addGoods.vue?vue&type=template&id=37b9de35&scoped=true&", function () {
      api.rerender('37b9de35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/onlineshop/addGoods.vue"
export default component.exports